import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const redirectTo = window.location.origin + '/reset-password';
      const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });

      if (error) throw error;

      setSuccess(true);
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Wystąpił błąd';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-viewport"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          width: '100%',
          maxWidth: '400px',
        }}
      >
        <h1 style={{ textAlign: 'center', marginBottom: '10px', color: '#333' }}>
          Zapomniałem/am hasła
        </h1>
        <p
          style={{
            textAlign: 'center',
            color: '#666',
            fontSize: '14px',
            marginBottom: '20px',
          }}
        >
          Wpisz email przypisany do konta. Wyślemy link do resetowania hasła.
        </p>

        {error && (
          <div
            style={{
              padding: '12px',
              backgroundColor: '#ffebee',
              color: '#c62828',
              borderRadius: '5px',
              marginBottom: '20px',
              fontSize: '14px',
            }}
          >
            {error}
          </div>
        )}

        {success ? (
          <>
            <div
              style={{
                padding: '12px',
                backgroundColor: '#e8f5e9',
                color: '#2e7d32',
                borderRadius: '5px',
                marginBottom: '20px',
                fontSize: '14px',
              }}
            >
              Sprawdź maila
            </div>
            <div style={{ textAlign: 'center' }}>
              <Link
                to="/login"
                style={{
                  color: '#4CAF50',
                  textDecoration: 'underline',
                  fontSize: '14px',
                  fontWeight: 'bold',
                }}
              >
                Wróć do logowania
              </Link>
            </div>
          </>
        ) : (
          <>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: 'bold',
                  color: '#555',
                }}
              >
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  fontSize: '16px',
                  boxSizing: 'border-box',
                }}
                placeholder="twoj@email.com"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: loading ? '#ccc' : '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: loading ? 'not-allowed' : 'pointer',
                marginBottom: '15px',
              }}
            >
              {loading ? 'Ładowanie...' : 'Wyślij link resetujący'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Link
              to="/login"
              style={{
                color: '#4CAF50',
                textDecoration: 'underline',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              Wróć do logowania
            </Link>
          </div>
        </>
        )}
      </div>
    </div>
  );
};
